"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const svLocaleData = require("i18next-icu/locale-data/sv");
exports.default = svLocaleData;
//# sourceMappingURL=sv.js.map